// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import type { KeyValueStore } from "./amyTurnStore"

/**
 * ADR-079: the web binding of the pending-turn record — localStorage (it
 * must survive a tab reload and a drawer remount), same key idiom as the
 * conversation cache (`bb_amy_turn_<userKey>`), best-effort like every
 * other cache: the server stays the authority on the turn.
 */
export function browserTurnStore(): KeyValueStore {
  return {
    get: key => {
      try {
        return window.localStorage.getItem(key)
      } catch {
        return null
      }
    },
    set: (key, value) => {
      try {
        window.localStorage.setItem(key, value)
      } catch {
        /* cache only — the server stays authoritative */
      }
    },
    remove: key => {
      try {
        window.localStorage.removeItem(key)
      } catch {
        /* best-effort */
      }
    },
  }
}
